/**
 * Resolves the MI token audience for a connector by reading
 * `connectionParameterSets.values[*].parameters[*].managedIdentitySettings.resourceUri`
 * — the field Logic Apps Standard uses for the `aud` claim. Returns undefined
 * for non-MI-capable connectors or while the connector resource is loading.
 */

import { useMemo } from 'react';
import { extractMiAudienceFromConnector } from '@/services/dynamicConnectionService';
import { useConnector } from '@/hooks/useConnector';

export function useMiAudience(
  connectorId: string | undefined | null,
  parameterSetName?: string
): string | undefined {
  const { data: connector } = useConnector(connectorId);
  return useMemo(
    () => extractMiAudienceFromConnector(connector, parameterSetName),
    [connector, parameterSetName]
  );
}
